import { LikeIcon } from './icons';
import { ACTIVITY_DETAILS_COLORS, ACTIVITY_DETAILS_RADIUS, ACTIVITY_DETAILS_SHADOWS } from './constants';

interface LikeCountBadgeProps {
  count: number;
  className?: string;
}

/**
 * LikeCountBadge Component
 * 
 * Badge showing like count with thumbs up icon.
 * Used on activity images.
 * 
 * Design specs:
 * - Background: rgba(0, 0, 0, 0.3) with backdrop blur
 * - Border radius: 12px
 * - Padding: 4px 8px
 * - Shadow: 0px 0px 24px rgba(0, 0, 0, 0.25)
 * - Icon: 14x14px white
 * - Text: DM Sans Medium 12px, white
 * - Gap between icon and text: 4px
 */
export default function LikeCountBadge({ count, className = '' }: LikeCountBadgeProps) {
  return (
    <div
      className={`flex items-center gap-1 ${className}`}
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        //backdropFilter: 'blur(12px)',
        //WebkitBackdropFilter: 'blur(12px)',
        borderRadius: `${ACTIVITY_DETAILS_RADIUS.likeBadge}px`,
        padding: '4px 8px',
        boxShadow: ACTIVITY_DETAILS_SHADOWS.likeBadge,
      }}
    >
     <LikeIcon size={14} color={ACTIVITY_DETAILS_COLORS.white} />
       <span
        className="font-medium"
        style={{
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '12px',
          color: ACTIVITY_DETAILS_COLORS.white,
        }}
      >
        {count} {count === 1 ? 'parent' : 'parents'} liked this activity
      </span>
    </div>
  );
}
